import { render, staticRenderFns } from "./Tongji.vue?vue&type=template&id=f806574e&"
import script from "./Tongji.vue?vue&type=script&lang=js&"
export * from "./Tongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports